import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { Field, Formik, Form } from "formik";
import { useMutation, useQuery } from "react-query";
import Navbar from "../../Components/Navbar";
import axios from "axios";
import Config from "../../Config";
import MenuItem from "@mui/material/MenuItem";
import ViewModal from "../../Components/Applications/PreviewModel";
import CompleteModal from "../../Components/Applications/CompleteModel";

import {
  gDistrictsList,
  gRegionsList,
  gTypeOfRegistration,
  gTypeOfAssociations,
  //gTypeOfGame
} from "../../Config";
import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
  BoxSubTitle,
} from "../../Components/Styles/PageStyles";
import {
  SubmitBtn,
  PreviewBtn,
  SaveBtn,
  InputGroup,
  FieldWrapper,
  Label,
  FormContainer,
  CombineInputGroup,
} from "../../Components/Styles/InputStyles";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../Components/Loading";
import moment from "moment";
import { HiUpload } from "react-icons/hi";
import { MdAdd, MdKeyboardArrowLeft } from "react-icons/md";
import { toast } from "react-toastify";
import Checkbox from "react-custom-checkbox";
import { BsCheckLg } from "react-icons/bs";
import { Update_User } from "../../Redux/actions";
import DropZone from "../../Components/Applications/DropzoneForSignatures";
import { useTranslation } from "react-i18next";
import Select from "@mui/material/Select";
//import Select from "react-select";

const EditRegistrationForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [selected, setSelected] = useState([]);

  const [openUploadModel, setOpenUploadModel] = useState(false);
  const [openSenderIdModel, setOpenSenderIdModel] = useState(false);
  const [isSendLater, setIsSendLater] = useState(false);
  // const [isAffiliated, setIsAffiliated] = useState(false);
  const [isAffiliated, setIsAffiliated] = useState({ yes: false, no: false });
  const [isRestricted, setIsRestricted] = useState({ yes: false, no: false });
  const [isRegistered, setIsRegistered] = useState({ yes: false, no: false });
  const [isInterested, setIsInterested] = useState({ yes: false, no: false });
  const [game, setGame] = useState("");
  const [gameLabel, setGameLabel] = useState("");
  const [isSave, setIsSave] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedBody, setSelectedBody] = useState(null);

  const [openViewModel, setOpenViewModel] = useState(false);
  const [completeViewModel, setCompleteViewModel] = useState(false);

  const gTypeOfGame = useSelector((state) => state?.GamesDataReducer?.games);

  
  const GameList = gTypeOfGame.map((item) => ({
    value: item.id,
    label: item.name,
  }));
  // const [isRestricted, setIsRestricted] = useState(false);
  // const [isRegistered, setIsRegistered] = useState(false);
  // const [isInterested, setIsInterested] = useState(false);
  const [typeOfAssocLabel, setTypeOfAssocLabel] = useState("");
  const [typeOfAssoc, setTypeOfAssoc] = useState("");

  const [typeOfRegLabel, setTypeOfRegLabel] = useState("");
  const [typeOfReg, setTypeOfReg] = useState("");

  const [regionLabel, setRegionLabel] = useState("");
  const [region, setRegion] = useState("");

  const [districtLabel, setDistrictLabel] = useState("");
  const [district, setDistrict] = useState("");

  const [isSubmitable, setIsSubmitable] = useState(false);

  const [uploadFile, setUploadFile] = useState("");
  const [chairmanSignature, setChairmanSignature] = useState("");
  const [secretarySignature, setSecretarySignature] = useState("");
  //console.log(allDistrictsList);

  const [districtsList, setDistricts] = useState([]);
  const [assocList, setAssociation] = useState([ {
    id: "1",
    name: "Sports Centre",
  }]);

  const user = useSelector((state) => state?.UserReducer?.user);


  const [isInitialValueSaved, setIsInitialValueSaved] = useState(true);
  const [previewOpenModel, setPreviewOpenModel] = useState(false);


  const [isBasicFormOpen, setIsBasicFormOpen] = useState(true);
  const [isReportDetailsOpen, setIsReportDetailsOpen] = useState(true);

  const { id } = useParams();

  const toggleBasicFormOpen = () => setIsBasicFormOpen(!isBasicFormOpen);

  const toggleReportDetailsOpen = () =>
    setIsReportDetailsOpen(!isReportDetailsOpen);
    
  // -------------  Initial Data -------------
  const fetchFunction = async () => {
    const body = new FormData();
    //body.append("token", user.email);
    body.append("userType", user.userType);
    body.append("id", id);
    setIsInitialValueSaved (true);
    return await axios.post(`${Config.apiUrl}/getassoregdata`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    }); 
  }

  const {
    data,
    error,
    isLoading: InitialLoading,
  } = useQuery(`getassoregdata`, fetchFunction);


  useEffect(()=>{
    // console.log(data?.data)
    if (data != undefined)
    {
      if (data?.data?.data?.isRestricted == "0") {
        setIsRestricted(() => ({
          yes: false,
          no: true,
        }));
      }
      if (data?.data?.data?.isRestricted == "1") {
        setIsRestricted(() => ({
          yes: true,
          no: false,
        }));
      }
      if (data?.data?.data?.isAffiliated == "0") {
        setIsAffiliated(() => ({
          yes: false,
          no: true,
        }));
      }
      if (data?.data?.data?.isAffiliated == "1") {
        setIsAffiliated(() => ({
          yes: true,
          no: false,
        }));
      }
      if (data?.data?.data?.is337 == "0") {
        setIsRegistered(() => ({
          yes: false,
          no: true,
        }));
      }
      if (data?.data?.data?.is337 == "1") {
        setIsRegistered(() => ({
          yes: true,
          no: false,
        }));
      }
      if (data?.data?.data?.isInterestInLand == "0") {
        setIsInterested(() => ({
          yes: false,
          no: true,
        }));
      }
      if (data?.data?.data?.isInterestInLand == "1") {
        setIsInterested(() => ({
          yes: true,
          no: false,
        }));
      }
      //if (data?.data?.data?.games != null)
        //setSelected(Array.from(data?.data?.data?.games?.split(','),Number))
      setTypeOfReg (data?.data?.data?.typeOfReg);
      setTypeOfRegLabel (data?.data?.data?.typeOfRegLabel);
      setTypeOfAssocLabel (data?.data?.data?.typeOfAssocLabel);
      setRegionLabel (data?.data?.data?.regionLabel);
      setDistrictLabel (data?.data?.data?.districtLabel);
      SetDynamicAssociation (data?.data?.data?.typeOfReg);
      SetDynamicDistricts (data?.data?.data?.region);
    }
    //setIsInitialValueSaved (false);
    //setGameLabel(data?.data?.data?.gameLabel);
  },[data])
  //setTypeOfReg (data?.data?.data?.typeOfReg);
  //setTypeOfRegLabel (data?.data?.data?.typeOfRegLabel);


  // -------------   Run Campaign  -------------
  const postFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/editapplication`, values, {
      headers: {
        authorization: user.token,
        "Content-type": "multipart/form-data",
      },
    });
  };

  const onSuccess = (res) => {
    if (res?.data?.status == "OK") {
      toast.success(res?.data?.msg || "Success");
      navigate("/my-applications");
    } else toast.error(res?.data?.msg || "Error");
  };

  const onError = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: isLoading, mutate: assocRegisterMutate } = useMutation(
    postFunction,
    {
      onSuccess: onSuccess,
      onError: onError,
    }
  );

  const InitialValue = {
    id: data?.data?.data?.id || "",
    assocName: data?.data?.data?.assocName || "",
    //games: data?.data?.data?.games || "",
    //gameLabel: data?.data?.data?.gameLabel || "",
    typeOfReg: data?.data?.data?.typeOfReg || "",
    typeOfRegLabel: data?.data?.data?.typeOfRegLabel || "",
    typeOfAssoc: data?.data?.data?.typeOfAssoc || "",
    typeOfAssocLabel: data?.data?.data?.typeOfAssocLabel || "",
    region: data?.data?.data?.region || "",
    regionLabel: data?.data?.data?.regionLabel || "",
    district: data?.data?.data?.district || "",
    districtLabel: data?.data?.data?.districtLabel || "",
    officeAddr: data?.data?.data?.officeAddr || "",
    postalAddr: data?.data?.data?.postalAddr || "",
    objective: data?.data?.data?.objective || "",
    isAffiliated: isAffiliated.yes,
    affiliateInfo: data?.data?.data?.affiliateInfo || "",
    isRestricted: isRestricted.yes,
    restrictionInfo: data?.data?.data?.restrictionInfo || "",
    noOfMembers: data?.data?.data?.noOfMembers || "",
    formationDate: data?.data?.data?.formationDate || "",
    is337: isRegistered.yes,
    name337: data?.data?.data?.name337 ||  "",
    number337: data?.data?.data?.number337 ||  "",
    purpose337: data?.data?.data?.purpose337 ||  "",
    isInterestInLand: isInterested.yes,
    landDetails: data?.data?.data?.landDetails ||  "",
    officeBearTitle: data?.data?.data?.officeBearTitle ||  "",
    holderNames: data?.data?.data?.holderNames ||  "",
    holdingTerms: data?.data?.data?.holdingTerms ||  "",
    chairmanName: data?.data?.data?.chairmanName ||  "",
    //chairmanSignature: data?.data?.data?.chairmanSignature ||  "",
    secretaryName: data?.data?.data?.secretaryName ||  "",
    //secretarySignature: data?.data?.data?.secretarySignature ||  "",
    annexADoc: "",
    annexBDoc: "",
  };
  // console.log(isAffiliated);
  //console.log(isRestricted);
  // console.log(isRegistered);
  // console.log(isInterested);

  const SubmitHandler = (values) => {
    if (isSubmitable  && isSubmit) {
      const body = new FormData();
        //body.append("assoRegister", values);
        body.append("id", values.id);
        body.append("email", user.email);
        body.append("assocName", values.assocName);
        body.append("typeOfAssoc", values.typeOfAssoc);
        body.append("typeOfReg", values.typeOfReg);
        body.append("region", values.region);
        body.append("district", values.district);
        body.append("typeOfAssocLabel", typeOfAssocLabel);
        body.append("typeOfRegLabel", typeOfRegLabel);
        body.append("regionLabel", regionLabel);
        body.append("districtLabel", districtLabel);
        body.append("officeAddr", values.officeAddr);
        body.append("postalAddr", values.postalAddr);
        body.append("objective", values.objective);
        if (isAffiliated.yes != false)
        {
          body.append("isAffiliated", 1);
          body.append("affiliateInfo", values.affiliateInfo);
        }
        else
        {
          body.append("isAffiliated", 0);
          body.append("affiliateInfo", '');
        }
        
        //body.append("affiliateInfo", values.affiliateInfo);
  
        if (isRestricted.yes != false)
        {
          body.append("isRestricted", 1);
          body.append("restrictionInfo", values.restrictionInfo);
        }
        else
        {
          body.append("isRestricted", 0);
          body.append("restrictionInfo", "");
        }
        // body.append("isRestricted", isRestricted.yes);
        
  
        body.append("noOfMembers", values.noOfMembers);
        body.append("formationDate", values.formationDate);
        if (isRegistered.yes != false)
          body.append("is337", 1);
        else 
          body.append("is337", 0);
        // body.append("is337", isRegistered.yes);
        body.append("name337", values.name337);
        body.append("number337", values.number337);
        body.append("purpose337", "");
  
        if (isInterested.yes != false)
          body.append("isInterestInLand", 1);
        else
          body.append("isInterestInLand", 0);
        // body.append("isInterestInLand", isInterested.yes);
        body.append("landDetails", values.landDetails);
        body.append("officeBearTitle", values.officeBearTitle);
        body.append("holderNames", values.holderNames);
        body.append("holdingTerms", values.holdingTerms);
        body.append("chairmanName", values.chairmanName);
        body.append("secretaryName", values.secretaryName);
        body.append("secretarySignature", secretarySignature);
        body.append("annexADoc", values.annexADoc);
        body.append("annexBDoc", values.annexBDoc);
        body.append("chairmanSignature", chairmanSignature);
        body.append("games", values.game);
        body.append("gameLabel", gameLabel);
        // console.log(game);
        // if (game && game != '') {
        //   const selectedGames = [];
        //   values.games.map((ele) => selectedGames.push(ele.value));
        //   body.append("games", selectedGames);
        //   console.log(selectedGames);
        // }
        // else
        // {
        //   body.append("games", ''); 
        // }
        // const selectedGames = [];
        // console.log(values.games);
        // values.games.map((ele) => selectedGames.push(ele.value));
        // body.append("games", selectedGames);
      if (!values.assocName) {
      return toast.error("Please select AssocName");
      }
      else if (!game || game == '')
      {
        return toast.error("Please enter Type of Games");
      }
      else if (!values.typeOfReg) {
        return toast.error("Please enter Type of Registration");
      }else if (!values.typeOfAssoc) {
        return toast.error("Please select Type Of Association");
      }else if (!values.region) {
        return toast.error("Please enter Region");
      } else if (!values.district) {
        return toast.error("Please select District");
      }
      else if (!values.officeAddr) {
        return toast.error("Please enter Office Address");
      }else if (!values.postalAddr) {
        return toast.error("Please enter Postal Address");
      }else if (!values.objective) {
        return toast.error("Please enter Objective");
      }
      else if (!values.noOfMembers) {
        return toast.error("Please enter No Of Members");
      }
      // else if (!values.formationDate) {
      //   return toast.error("Please select Formation Date");
      // }
      else if (!values.officeBearTitle) {
        return toast.error("Please enter Office Bear Title");
      }else if (!values.holderNames) {
        return toast.error("Please enter Holder Names");
      }else if (!values.holdingTerms) {
        return toast.error("Please enter Holding Terms");
      }else if (!values.chairmanName) {
        return toast.error("Please enter Chairman Name");
      }
      else if (!chairmanSignature && !data?.data?.data?.chairmanSignature) {
        return toast.error("Please upload Chairman Signature");
      } 
      else if (!values.secretaryName) {
        return toast.error("Please enter Secretary Name");
      }
      else if (!secretarySignature && !data?.data?.data?.secretarySignature) {
        return toast.error("Please upload Secretary Signature");
      }
      else 
      {
        setSelectedItem(values);
        setSelectedBody(body);
        setCompleteViewModel (true);
          //assocRegisterMutate(body);
      }
      
      
    } 
    else if (isSave == true) {
      if (!values.assocName) {
        return toast.error("Please enter Association Name");
      }
      else {
        SaveFormHandler (values);
        //
      }
    }
    else {
      //setIsSubmitable(true);
    }
  };

  const SaveFormHandler = (values) => {
    const body = new FormData();
    //body.append("assoRegister", values);
    body.append("id", values.id);
    body.append("custId", user.id);
    body.append("email", user.email);
    body.append("assocName", values.assocName);
    body.append("typeOfAssoc", values.typeOfAssoc);
    body.append("typeOfReg", values.typeOfReg);
    body.append("region", values.region);
    body.append("district", values.district);
    body.append("typeOfAssocLabel", values.typeOfAssocLabel);
    body.append("typeOfRegLabel", values.typeOfRegLabel);
    body.append("regionLabel", values.regionLabel);
    body.append("districtLabel", values.districtLabel);
    body.append("officeAddr", values.officeAddr);
    body.append("postalAddr", values.postalAddr);
    body.append("objective", values.objective);
    if (isAffiliated.yes != false)
    {
      body.append("isAffiliated", 1);
      body.append("affiliateInfo", values.affiliateInfo);
    }
    else
    {
      body.append("isAffiliated", 0);
      body.append("affiliateInfo", "");
    }
    
    if (isRestricted.yes != false)
    {
      body.append("isRestricted", 1);
      body.append("restrictionInfo", values.restrictionInfo);
    }
    else
    {
      body.append("isRestricted", 0);
      body.append("restrictionInfo", "");
    }
    
    body.append("noOfMembers", values.noOfMembers);
    body.append("formationDate", values.formationDate);
    if (isRegistered.yes != false)
    {
      body.append("is337", 1);
      body.append("name337", values.name337);
      body.append("number337", values.number337);
    }
    else
    {
      body.append("is337", 0);
      body.append("name337", "NA");
      body.append("number337", "NA");
    }
    // if (!values.purpose337) {
    //   return toast.error("Please enter Association purpose");
    // }
    body.append("purpose337", "NA");
    if (isInterested.yes != false)
      body.append("isInterestInLand", 1);
    else
      body.append("isInterestInLand", 0);
    if (isInterested.yes != false) {
      if (!values.landDetails) {
        return toast.error("Please enter Land Details");
      }
    }
    body.append("landDetails", values.landDetails);
    body.append("officeBearTitle", values.officeBearTitle);
    body.append("holderNames", values.holderNames);
    body.append("holdingTerms", values.holdingTerms);
    body.append("chairmanName", values.chairmanName);
    body.append("secretaryName", values.secretaryName);
    body.append("secretarySignature", secretarySignature);
    body.append("annexADoc", values.annexADoc);
    body.append("annexBDoc", values.annexBDoc);
    body.append("chairmanSignature", chairmanSignature);
    body.append("game", values.game);
    if (values.games && values.games != '') {
      const selectedGames = [];
      values.games.map((ele) => selectedGames.push(ele.value));
      body.append("games", selectedGames);
    }
    else
    {
      body.append("games", ''); 
    }
    body.append("gameLabel", values.gameLabel);
    setSelectedItem(values);
    assocRegisterMutateSave(body);
  };

  const RegistrationList = gTypeOfRegistration.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const AssociationList = assocList.map((item) => ({
    id: item.id,
    name: item.name,
  }));


  const RegionList = gRegionsList.map((item) => ({
    id: item.id,
    name: item.name,
  }));

  const SetDynamicDistricts = (value) => {
    if (value == null)
      value = 1;
    setDistricts(gDistrictsList[value]);
  };

  const SetDynamicAssociation = (value) => {
    if (value == null)
      value = 1;
    setAssociation(gTypeOfAssociations[value]);
  };

  const DistrictList = districtsList.map((item) => ({
    id: item.id,
    name: item.name,
  }));

  // -------------   Save Application  -------------
  const postFunctionSave = async (values) => {
    if (openViewModel == false) {
      return await axios.post(`${Config.apiUrl}/editsavedapplication`, values, {
        headers: {
          authorization: user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      });
    }
  };

  const onSuccessSave = (res) => {
    if (res?.data?.status == "OK") {
      toast.success(res?.data?.msg || "Success");
      navigate("/my-applications");
    } else toast.error(res?.data?.msg || "Error");
  };

  const onErrorSave = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: isLoadingSave, mutate: assocRegisterMutateSave } = useMutation(
    postFunctionSave,
    {
      onSuccess: onSuccessSave,
      onError: onErrorSave,
    }
  );
  /************ End Save Application **************/

  const setSubmitForm = () => {
    assocRegisterMutate (selectedBody);
  }

  const setPrevieForm = () => {
    setCompleteViewModel (false);
    setPreviewOpenModel (true);
  }
  
  return (
    <>
      <Navbar />
      {previewOpenModel && (
        <ViewModal
          setPreviewOpenModel={setPreviewOpenModel}
          selectedItem={selectedItem}
        />
      )}
      {completeViewModel && (
        <CompleteModal
          setPrevieForm={setPrevieForm}
          setSubmitForm={setSubmitForm}
          setCompleteViewModel={setCompleteViewModel}
          selectedItem={selectedItem}
        />
      )}
      <Page>
        <BoxContainer>
          <BoxTitle onClick={() => navigate(-1)}>
            {/* <MdKeyboardArrowLeft className="text-gray-700 w-6 h-6" /> */}
            <p>{t("App_Registration")}</p>
          </BoxTitle>
          <Underline />
          <BoxSubTitle>{t("national_sport")}</BoxSubTitle>

          <Formik
            initialValues={InitialValue}
            onSubmit={SubmitHandler}
            enableReinitialize={isInitialValueSaved}
          >
            {(formikProps) => (
              <>
                <Form>
                  <FormContainer className="md:mt-8">
                    {!isSubmitable ? (
                      <>
                      {/* <CombineInputGroup> */}
                        <InputGroup>
                          <Label htmlFor="assocName">{t("a_name")}</Label>
                          <FieldWrapper>
                            <Field
                              name="assocName"
                              id="assocName"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>

                        {/* <InputGroup>
                            <Label htmlFor="game">{t("TypeOfGame")}</Label>
                            <FieldWrapper $select={true}>
                              <Field
                                required
                                name="game"
                                id="game"
                                autoComplete="off"
                              >
                                {(props) => (
                                  <Select
                                    className="w-full h-full"
                                    isMulti
                                    options={GameList}
                                    defaultValue={{
                                      label: gameLabel,
                                      value: game,
                                    }}
                                    onChange={(val) => {
                                      setGameLabel(val.label);
                                      setGame(val.value);
                                      props.form.setFieldValue(
                                        "games",
                                        val
                                      );
                                      props.form.setFieldValue(
                                        "game",
                                        val.value
                                      );
                                      props.form.setFieldValue(
                                        "gameLabel",
                                        val.label
                                      );
                                    }}
                                  />
                                )}
                              </Field>
                            </FieldWrapper>
                         
                        </InputGroup> */}
                        <InputGroup>
                            <Label htmlFor="name">
                              {t("TypeOfGame")}
                            </Label>
                            <FieldWrapper $select={true}>
                              <Field
                                required
                                name="games"
                                id="games"
                                autoComplete="off"
                              >
                                {(props) => (
                                <Select
                                // {...props.field}
                                multiple
                                value={selected}
                                  className="w-full h-full pl-2 bg-transparent text-sm p-0  border-none"
                                  onChange={(e) => {
                                    const selectedItem = gTypeOfGame.find(item => item.id == e.target.value);
                                    setGame(e.target.value);
                                    //setGameLabel (selectedItem.name);
                                    setSelected(e.target.value)
                                    props.form.setFieldValue(
                                      "game",
                                      e.target.value
                                    );
                                    props.form.setFieldValue(
                                      "games",
                                      e.target
                                    );
                                   
                                  }}
                                >
                                  {gTypeOfGame.map(item=>(
                                      <MenuItem value={item.id}>{item.name}</MenuItem>
                                  ))}
                                  
                                </Select>
                                )}
                              </Field>
                            </FieldWrapper>
                          </InputGroup>


                        {/* </CombineInputGroup> */}
                        <CombineInputGroup>
                          <InputGroup>
                            <Label htmlFor="typeOfReg">
                              {t("t_registration")}
                            </Label>
                            <FieldWrapper $select={true}>
                              <Field
                                required
                                name="typeOfReg"
                                id="typeOfReg"
                                autoComplete="off"
                              >
                                {(props) => (

                                <Select
                                {...props.field}
                                  className="w-full h-full pl-2 bg-transparent text-sm p-0  border-none"
                                  options={RegistrationList}
                                  onChange={(e) => {
                                    const selectedItem = gTypeOfRegistration.find(item => item.id == e.target.value);
                                    setTypeOfRegLabel (selectedItem.name);
                                    SetDynamicAssociation(e.target.value);
                                    props.form.setFieldValue(
                                      "typeOfReg",
                                      e.target.value
                                    );
                                   
                                  }}
                                >
                                  {gTypeOfRegistration.map(item=>(
                                      <MenuItem value={item.id}>{item.name}</MenuItem>
                                  ))}
                                  
                                </Select>



                                  // <Select
                                  //   className="w-full h-full"
                                  //   options={RegistrationList}
                                  //   defaultValue={{
                                  //     label: 'Clubs',
                                  //     value: 2,
                                  //   }}
                                    
                                  // />
                                )}
                              </Field>
                            </FieldWrapper>
                          </InputGroup>
                          <InputGroup>
                            <Label htmlFor="typeOfAssocLabel">
                              {t("t_association")}
                            </Label>
                            <FieldWrapper $select={true}>
                              <Field
                                required
                                name="typeOfAssoc"
                                id="typeOfAssoc"
                                autoComplete="off"
                              >
                                {(props) => (

                                  <Select
                                  {...props.field}
                                    className="w-full h-full pl-2 bg-transparent text-sm p-0  border-none"
                                    options={AssociationList}
                                    // defaultValue={{
                                    //   label: typeOfAssocLabel,
                                    //   value: typeOfAssoc,
                                    // }}
                                    onChange={(e) => {
                                      const selectedItem = AssociationList.find(item => item.id == e.target.value);
                                      setTypeOfAssocLabel (selectedItem.name);
                                      props.form.setFieldValue(
                                        "typeOfAssoc",
                                        e.target.value
                                      );
                                    
                                    }}
                                    
                                    >
                                    {AssociationList.map(item=>(
                                        <MenuItem value={item.id}>{item.name}</MenuItem>
                                    ))}
                                    
                                  </Select>


                                  // <Select
                                  //   className="w-full h-full"
                                  //   options={AssociationList}
                                  //   defaultValue={{
                                  //     label: typeOfAssocLabel,
                                  //     value: typeOfAssoc,
                                  //   }}
                                  //   onChange={(val) => {
                                  //     setTypeOfAssocLabel(val.label);
                                  //     setTypeOfAssoc(val.value);
                                  //     props.form.setFieldValue(
                                  //       "typeOfAssoc",
                                  //       val.value
                                  //     );
                                  //     props.form.setFieldValue(
                                  //       "typeOfAssocLabel",
                                  //       val.label
                                  //     );
                                  //   }}
                                  // />
                                )}
                              </Field>
                            </FieldWrapper>
                          </InputGroup>
                        </CombineInputGroup>
                        <CombineInputGroup>
                          <InputGroup>
                            <Label htmlFor="region">{t("c_region")}</Label>
                            <FieldWrapper $select={true}>
                              <Field
                                required
                                name="region"
                                id="region"
                                autoComplete="off"
                              >
                                {(props) => (



                                    <Select
                                    {...props.field}
                                      className="w-full h-full pl-2 bg-transparent text-sm p-0  border-none"
                                      onChange={(e) => {
                                        const selectedItem = gRegionsList.find(item => item.id == e.target.value);
                                        setRegionLabel (selectedItem.name);
                                        SetDynamicDistricts(e.target.value);
                                        props.form.setFieldValue(
                                          "region",
                                          e.target.value
                                        );
                                        props.form.setFieldValue(
                                          "regionLabel",
                                          selectedItem.name
                                        );
                                      
                                      }}
                                    >
                                      {gRegionsList.map(item=>(
                                          <MenuItem value={item.id}>{item.name}</MenuItem>
                                      ))}
                                      
                                    </Select>



                                  // <Select
                                  //   className="w-full h-full"
                                  //   options={RegionList}
                                  //   defaultValue={{
                                  //     label: regionLabel,
                                  //     value: region,
                                  //   }}
                                  //   onChange={(val) => {
                                  //     setRegionLabel(val.label);
                                  //     setRegion(val.value);
                                  //     SetDynamicDistricts(val.value);
                                  //     props.form.setFieldValue(
                                  //       "region",
                                  //       val.value
                                  //     );
                                  //     props.form.setFieldValue(
                                  //       "regionLabel",
                                  //       val.label
                                  //     );
                                  //   }}
                                  // />
                                )}
                              </Field>
                            </FieldWrapper>
                          </InputGroup>
                          <InputGroup>
                            <Label htmlFor="district">{t("C_District")}</Label>
                            <FieldWrapper $select={true}>
                              <Field
                                required
                                name="district"
                                id="district"
                                autoComplete="off"
                              >
                                {(props) => (


                                    <Select
                                    {...props.field}
                                      className="w-full h-full pl-2 bg-transparent text-sm p-0  border-none"
                                      onChange={(e) => {
                                        const selectedItem = DistrictList.find(item => item.id == e.target.value);
                                        setDistrictLabel (selectedItem.name);
                                        //SetDynamicDistricts(e.target.value);
                                        props.form.setFieldValue(
                                          "district",
                                          e.target.value
                                        );
                                        props.form.setFieldValue(
                                          "districtLabel",
                                          selectedItem.name
                                        );
                                      
                                      }}
                                    >
                                      {DistrictList.map(item=>(
                                          <MenuItem value={item.id}>{item.name}</MenuItem>
                                      ))}
                                      
                                    </Select>

                                  // <Select
                                  //   className="w-full h-full"
                                  //   options={DistrictList}
                                  //   defaultValue={{
                                  //     label: districtLabel,
                                  //     value: district,
                                  //   }}
                                  //   onChange={(val) => {
                                  //     setDistrictLabel(val.label);
                                  //     setDistrict(val.value);
                                  //     props.form.setFieldValue(
                                  //       "district",
                                  //       val.value
                                  //     );
                                  //     props.form.setFieldValue(
                                  //       "districtLabel",
                                  //       val.label
                                  //     );
                                  //   }}
                                  // />
                                )}
                              </Field>
                            </FieldWrapper>
                          </InputGroup>
                        </CombineInputGroup>

                        <InputGroup>
                          <Label htmlFor="officeAddr">
                            {t("Office_Address")}
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="officeAddr"
                              id="officeAddr"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>

                        <InputGroup>
                          <Label htmlFor="postalAddr">
                            {t("Postal_Address")}
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="postalAddr"
                              id="postalAddr"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>

                        <InputGroup>
                          <Label htmlFor="objective">
                            {t("Objectives_Association")}
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="objective"
                              as="textarea"
                              rows="6"
                              id="objective"
                              placeholder={t("Type_here")}
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>
{/* copy here */}
                      <LabelCheckboxWrapper>
                          <Label
                            style={{
                              fontSize: 14,
                              color: "#808080",
                            }}
                          >
                            {t("association_branch")}
                          </Label>

                          <CheckboxWrapper>
                            <Checkbox
                              icon={
                                <BsCheckLg className="text-cyan-600 w-4 h-4" />
                              }
                              // name="my-input"
                              checked={isAffiliated.yes}
                              onChange={(value) => {
                                setIsAffiliated(() => ({
                                  yes: value,
                                  no: false,
                                }));
                              }}
                              borderColor="#808080"
                              labelStyle={{
                                marginLeft: 5,
                                fontSize: 14,
                                userSelect: "none",
                                color: "#808080",
                              }}
                              label={"Yes"}
                            />

                            <Checkbox
                              icon={
                                <BsCheckLg className="text-cyan-600 w-4 h-4" />
                              }
                              name="my-input"
                              checked={isAffiliated.no}
                              onChange={(value) => {
                                setIsAffiliated(() => ({
                                  yes: false,
                                  no: value,
                                }));
                              }}
                              borderColor="#808080"
                              labelStyle={{
                                marginLeft: 5,
                                fontSize: 14,
                                userSelect: "none",
                                color: "#808080",
                              }}
                              label={"No"}
                            />
                          </CheckboxWrapper>
                        </LabelCheckboxWrapper>
                        {isAffiliated.yes && (
                          <InputGroup>
                            <Label htmlFor="affiliateInfo">
                              {" "}
                              Give full particulars of such other
                              organizations(Affi. Info)
                            </Label>
                            <FieldWrapper>
                              <Field
                                name="affiliateInfo"
                                as="textarea"
                                rows="3"
                                id="affiliateInfo"
                                autoComplete="off"
                              />
                            </FieldWrapper>
                          </InputGroup>
                        )}
                      {/* end here */}
                        {/* <Checkbox
                          icon={<BsCheckLg className="text-cyan-600 w-4 h-4" />}
                          // name="my-input"
                          checked={isAffiliated}
                          onChange={(value) => {
                            setIsAffiliated(value);
                          }}
                          borderColor="#808080"
                          labelStyle={{
                            marginLeft: 5,
                            marginTop: 20,
                            fontSize: 14,
                            userSelect: "none",
                            color: "#808080",
                          }}
                          label={t("association_branch")}
                        />

                        {isAffiliated && (
                          <InputGroup>
                            <Label htmlFor="affiliateInfo">
                              {" "}
                              Give full particulars of such other
                              organizations(Affi. Info)
                            </Label>
                            <FieldWrapper>
                              <Field
                                name="affiliateInfo"
                                as="textarea"
                                rows="3"
                                id="affiliateInfo"
                                autoComplete="off"
                              />
                            </FieldWrapper>
                          </InputGroup>
                        )} */}

                        <LabelCheckboxWrapper>
                          <Label
                            style={{
                              fontSize: 14,
                              color: "#808080",
                            }}
                          >
                            {t("Is_membership")}
                          </Label>

                          <CheckboxWrapper>
                            <Checkbox
                              icon={
                                <BsCheckLg className="text-cyan-600 w-4 h-4" />
                              }
                              checked={isRestricted.yes}
                              onChange={(value) => {
                                setIsRestricted(() => ({
                                  yes: value,
                                  no: false,
                                }));
                              }}
                              borderColor="#808080"
                              labelStyle={{
                                marginLeft: 5,
                                fontSize: 14,
                                userSelect: "none",
                                color: "#808080",
                              }}
                              label={"Yes"}
                            />

                            <Checkbox
                              icon={
                                <BsCheckLg className="text-cyan-600 w-4 h-4" />
                              }
                              checked={isRestricted.no}
                              onChange={(value) => {
                                setIsRestricted(() => ({
                                  yes: false,
                                  no: value,
                                }));
                              }}
                              borderColor="#808080"
                              labelStyle={{
                                marginLeft: 5,
                                fontSize: 14,
                                userSelect: "none",
                                color: "#808080",
                              }}
                              label={"No"}
                            />
                          </CheckboxWrapper>
                        </LabelCheckboxWrapper>

                        {isRestricted.yes && (
                          <InputGroup>
                            <Label htmlFor="restrictionInfo">
                              {" "}
                              what class or classes of persons
                            </Label>
                            <FieldWrapper>
                              <Field
                                name="restrictionInfo"
                                as="textarea"
                                rows="3"
                                id="restrictionInfo"
                                autoComplete="off"
                              />
                            </FieldWrapper>
                          </InputGroup>
                        )}

                        {/* <Checkbox
                          icon={<BsCheckLg className="text-cyan-600 w-4 h-4" />}
                          // name="my-input"
                          checked={isRestricted}
                          onChange={(value) => {
                            setIsRestricted(value);
                          }}
                          borderColor="#808080"
                          labelStyle={{
                            marginLeft: 5,
                            fontSize: 14,
                            userSelect: "none",
                            color: "#808080",
                          }}
                          label={t("Is_membership")}
                        /> */}

                        {/* {isRestricted && (
                          <InputGroup>
                            <Label htmlFor="restrictionInfo">
                              {" "}
                              what class or classes of persons
                            </Label>
                            <FieldWrapper>
                              <Field
                                name="restrictionInfo"
                                as="textarea"
                                rows="3"
                                id="restrictionInfo"
                                autoComplete="off"
                              />
                            </FieldWrapper>
                          </InputGroup>
                        )} */}

                        <InputGroup>
                          <Label htmlFor="noOfMembers">
                            {t("Present_number")}
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="noOfMembers"
                              id="noOfMembers"
                              autoComplete="off"
                              type="number"
                            />
                          </FieldWrapper>
                        </InputGroup>
                      </>
                    ) : (
                      <>
                        <InputGroup>
                          <Label htmlFor="formationDate">
                            {t("Association_formed")}
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="formationDate"
                              id="formationDate"
                              autoComplete="off"
                              type="date"
                            />
                          </FieldWrapper>
                        </InputGroup>

                        {/* <Checkbox
                          icon={<BsCheckLg className="text-cyan-600 w-4 h-4" />}
                          name="my-input"
                          checked={isRegistered}
                          onChange={(value) => {
                            setIsRegistered(value);
                          }}
                          borderColor="#808080"
                          labelStyle={{
                            marginLeft: 5,
                            fontSize: 14,
                            userSelect: "none",
                            color: "#808080",
                          }}
                          label="Was it registered under societies Ordinance Cap. 337?"
                        />

                        {isRegistered && (
                          <>
                            <InputGroup>
                              <Label htmlFor="name337">{t("r_name")}</Label>
                              <FieldWrapper>
                                <Field
                                  name="name337"
                                  id="name337"
                                  autoComplete="off"
                                  type="text"
                                />
                              </FieldWrapper>
                            </InputGroup>
                            <InputGroup>
                              <Label htmlFor="number337">
                                Registration number
                              </Label>
                              <FieldWrapper>
                                <Field
                                  name="number337"
                                  id="number337"
                                  autoComplete="off"
                                  type="text"
                                />
                              </FieldWrapper>
                            </InputGroup>
                          </>
                        )} */}

                        <LabelCheckboxWrapper>
                          <Label
                            style={{
                              fontSize: 14,
                              color: "#808080",
                            }}
                          >
                            Was it registered under societies Ordinance Cap. 337?
                          </Label>

                          <CheckboxWrapper>
                            <Checkbox
                              icon={
                                <BsCheckLg className="text-cyan-600 w-4 h-4" />
                              }
                              // name="my-input"
                              checked={isRegistered.yes}
                              onChange={(value) => {
                                setIsRegistered(() => ({
                                  yes: value,
                                  no: false,
                                }));
                              }}
                              borderColor="#808080"
                              labelStyle={{
                                marginLeft: 5,
                                fontSize: 14,
                                userSelect: "none",
                                color: "#808080",
                              }}
                              label={"Yes"}
                            />

                            <Checkbox
                              icon={
                                <BsCheckLg className="text-cyan-600 w-4 h-4" />
                              }
                              name="my-input"
                              checked={isRegistered.no}
                              onChange={(value) => {
                                setIsRegistered(() => ({
                                  yes: false,
                                  no: value,
                                }));
                              }}
                              borderColor="#808080"
                              labelStyle={{
                                marginLeft: 5,
                                fontSize: 14,
                                userSelect: "none",
                                color: "#808080",
                              }}
                              label={"No"}
                            />
                          </CheckboxWrapper>
                        </LabelCheckboxWrapper>

                        {isRegistered.yes && (
                          <InputGroup>
                            <Label htmlFor="name337">
                              {t("r_name")}
                            </Label>
                            <FieldWrapper>
                              <Field
                                name="name337"
                                id="name337"
                                autoComplete="off"
                                type="text"
                              />                              
                            </FieldWrapper>
                            <Label htmlFor="number337">
                              Registration Number
                            </Label>
                            <FieldWrapper>
                              <Field
                                name="number337"
                                id="number337"
                                autoComplete="off"
                                type="text"
                              />                              
                            </FieldWrapper>
                          </InputGroup>
                        )}


                        {/* <InputGroup>
                          <Label htmlFor="postal">
                            In what District/Districts/Regions of Tanzania does
                            the Association carry on its activities?
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="postal"
                              id="postal"
                              autoComplete="off"
                              type="text"
                            />
                          </FieldWrapper>
                        </InputGroup> */}

                        {/* <InputGroup>
                          <Label htmlFor="purpose337">
                            What Sport/Sports does the Association intend to
                            pursue?
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="purpose337"
                              id="purpose337"
                              autoComplete="off"
                              type="text"
                            />
                          </FieldWrapper>
                        </InputGroup> */}

                        {/* <Checkbox
                          icon={<BsCheckLg className="text-cyan-600 w-4 h-4" />}
                          name="my-input"
                          checked={isInterested}
                          onChange={(value) => {
                            setIsInterested(value);
                          }}
                          borderColor="#808080"
                          labelStyle={{
                            marginLeft: 5,
                            fontSize: 14,
                            userSelect: "none",
                            color: "#808080",
                          }}
                          label="Does the Association have any interest in Land?"
                        />

                        {isInterested && (
                          <InputGroup>
                            <Label htmlFor="landDetails">
                              Give details of the land where possible by
                              reference to registration
                            </Label>
                            <FieldWrapper>
                              <Field
                                name="landDetails"
                                as="textarea"
                                rows="3"
                                id="landDetails"
                                autoComplete="off"
                              />
                            </FieldWrapper>
                          </InputGroup>
                        )} */}

                        <LabelCheckboxWrapper>
                          <Label
                            style={{
                              fontSize: 14,
                              color: "#808080",
                            }}
                          >
                            Does the Association have any interest in Land?
                          </Label>

                          <CheckboxWrapper>
                            <Checkbox
                              icon={
                                <BsCheckLg className="text-cyan-600 w-4 h-4" />
                              }
                              // name="my-input"
                              checked={isInterested.yes}
                              onChange={(value) => {
                                setIsInterested(() => ({
                                  yes: value,
                                  no: false,
                                }));
                              }}
                              borderColor="#808080"
                              labelStyle={{
                                marginLeft: 5,
                                fontSize: 14,
                                userSelect: "none",
                                color: "#808080",
                              }}
                              label={"Yes"}
                            />

                            <Checkbox
                              icon={
                                <BsCheckLg className="text-cyan-600 w-4 h-4" />
                              }
                              //name="my-input"
                              checked={isInterested.no}
                              onChange={(value) => {
                                setIsInterested(() => ({
                                  yes: false,
                                  no: value,
                                }));
                              }}
                              borderColor="#808080"
                              labelStyle={{
                                marginLeft: 5,
                                fontSize: 14,
                                userSelect: "none",
                                color: "#808080",
                              }}
                              label={"No"}
                            />
                          </CheckboxWrapper>
                        </LabelCheckboxWrapper>




                        {isInterested.yes && (
                          <InputGroup>
                            <Label htmlFor="landDetails">
                              {/* {" "}
                              Registration number */}
                              {/* {t("r_name")} */}
                              Give details of the land where possible by
                              reference to registration
                            </Label>
                            <FieldWrapper>
                              <Field
                                name="landDetails"
                                id="landDetails"
                                autoComplete="off"
                                as="textarea"
                                rows="3"
                              />                              
                            </FieldWrapper>
                          </InputGroup>
                        )}

                        <InputGroup>
                          <Label htmlFor="officeBearTitle">
                            Titles of the office bearers?
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="officeBearTitle"
                              id="officeBearTitle"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>
                        <InputGroup>
                          <Label htmlFor="holderNames">
                            Who are the present holders?
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="holderNames"
                              id="holderNames"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>
                        <InputGroup>
                          <Label htmlFor="holdingTerms">
                            What term do they hold?
                          </Label>
                          <FieldWrapper>
                            <Field
                              name="holdingTerms"
                              id="holdingTerms"
                              as="textarea"
                              rows="3"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>

                        <InputGroup>
                          <Label htmlFor="chairmanName">Chairman Name</Label>
                          <FieldWrapper>
                            <Field
                              name="chairmanName"
                              id="chairmanName"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>

                        <InputGroup>
                          <Label htmlFor="chairmanSignature">
                            Please upload Chairman Signature
                          </Label>
                          <DropZone setUploadFile={setChairmanSignature} />
                        </InputGroup>

                        <InputGroup>
                          <Label htmlFor="secretaryName">Secretary Name</Label>
                          <FieldWrapper>
                            <Field
                              name="secretaryName"
                              id="secretaryName"
                              autoComplete="off"
                            />
                          </FieldWrapper>
                        </InputGroup>

                        <InputGroup>
                          <Label htmlFor="secretarySignature">
                            Please upload Secretary Signature
                          </Label>
                          <DropZone setUploadFile={setSecretarySignature} />
                        </InputGroup>
                      </>
                    )}
                  </FormContainer>

                  <div className="mt-14">
                    {isSubmitable ? (
                      <div className="flex items-center space-x-10">
                        <PreviewBtn
                          type="button"
                          onClick={() => setIsSubmitable(false)}
                        >
                          Prev
                        </PreviewBtn>
                        <SaveBtn type="submit"
                          // type="button"
                          onClick={() => { setIsSave(true); setIsPreview(false); setIsSubmit(false); }}
                        >
                          Save
                        </SaveBtn>
                        <SubmitBtn type="submit" disabled={isLoading} onClick={() => { setIsSave(false); setIsPreview(false); setIsSubmit(true); }}>
                          {isLoading && (
                            <Loading
                              color="white"
                              width={20}
                              height={20}
                              noPadding={true}
                            />
                          )}
                          {!isLoading && "Update"}
                        </SubmitBtn>
                      </div>
                    ) : (
                      <SubmitBtn onClick={() => setIsSubmitable(true)}>
                        {t("Next")}
                      </SubmitBtn>
                    )}
                  </div>
                </Form>
              </>
            )}
          </Formik>
        </BoxContainer>
      </Page>
    </>
  );
};

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-52 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;

const LabelCheckboxWrapper = tw.div``;
const CheckboxWrapper = tw.div`flex items-center space-x-5 mt-2.5`;


export default EditRegistrationForm;
